import React from 'react';
import { usePermissions } from '../hooks/usePermissions';

interface Props {
  module: string;
  action: string;
  children: React.ReactNode;
}

export const ProtectedComponent: React.FC<Props> = ({ module, action, children }) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(module, action)) {
    return null;
  }

  return <>{children}</>;
};